import { render, staticRenderFns } from "./ParticipantRecruitment.vue?vue&type=template&id=8e6c53f6&"
import script from "./ParticipantRecruitment.vue?vue&type=script&lang=js&"
export * from "./ParticipantRecruitment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports